import { defineStyle } from '@chakra-ui/react';

export const buttonWithArrowCommonStyles = defineStyle({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  fontWeight: 'medium',
});
